(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-hot-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nb-stock')) {
  customElements.define('nb-stock', class extends HTMLElement {
    connectedCallback() {
      this.onChange = () => { clearTimeout(this.pending); this.pending = setTimeout(() => this.refresh(), 400); };
      this.onFocus = () => this.refresh();
      document.addEventListener('change', this.onChange);
      window.addEventListener('focus', this.onFocus);
      this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 30000);
    }
    disconnectedCallback() {
      clearInterval(this.timer); clearTimeout(this.pending);
      document.removeEventListener('change', this.onChange);
      window.removeEventListener('focus', this.onFocus);
      this.controller?.abort();
    }
    async refresh() {
      const section = document.getElementById('shopify-section-' + this.dataset.section);
      const input = section?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      const variant = input?.value || this.dataset.variant;
      this.controller?.abort();
      this.controller = new AbortController();
      const url = new URL(this.dataset.productUrl, location.origin);
      const current = new URL(location.href);
      for (const key of ['view', 'preview_theme_id']) {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      }
      url.searchParams.set('variant', variant);
      url.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(url, {signal: this.controller.signal});
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector('nb-stock .nb-stock-content');
        if (next && this.isConnected) {
          this.querySelector('.nb-stock-content').replaceWith(next);
          this.dataset.variant = variant;
        }
      } catch (error) { if (error.name !== 'AbortError') return; }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
